module.exports = __webpack_public_path__ + "media/images/home/cover-desktop-bee543cb59954b1046941e2387406136.jpg";